import React, { useState, useEffect } from 'react';
import api from '../api/axios';

const Configs = () => {
    const [config, setConfig] = useState({
        primaryColor: '#9d4edd',
        secondaryColor: '#1e293b',
        logoUrl: '',
        backgroundLogin: '#f3f4f6',
        backgroundImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png',
        buttonStyles: {
            borderRadius: '12px',
            padding: '12px 24px'
        }
    });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [message, setMessage] = useState('');

    const [pageControls, setPageControls] = useState({
        agenda: true,
        speakers: true,
        streaming: true
    });

    const [pageDesigns, setPageDesigns] = useState({
        home: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        agenda: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true, agendaImageOnly: false },
        speakers: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        streaming: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        gallery: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        profile: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        login: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        register: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        welcome: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        thanks: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        certificate: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        questions_private: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true },
        interactiva: { enabled: true, bgImage: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png', showBrain: true }
    });

    const [letters, setLetters] = useState({
        welcome: 'Bienvenido {name} {lastName} al evento...',
        thanks: 'Gracias {name} {lastName} por asistir...',
        certificate: 'Certificamos que {name} {lastName} ha participado...',
        certificateData: {
            imageUrl: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Certificado_4toNeuroUpdate_web.png',
            x: 50,
            y: 75,
            fontSize: 40,
            color: '#000000',
            bypassAttendance: false
        },
        thanksData: {
            imageUrl: 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png',
            x: 50,
            y: 50,
            fontSize: 40,
            color: '#ffffff'
        },
        thanksType: 'image',
        thanksStructuredData: []
    });

    const [regFields, setRegFields] = useState({
        identification: true,
        name: true,
        last_name: true,
        email: true,
        city: true,
        country: true
    });

    const [customPages, setCustomPages] = useState([]);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const [visualRes, pagesRes, customRes, designsRes, lettersRes, regRes] = await Promise.all([
                    api.get('/configs/visual_identity'),
                    api.get('/configs/page_controls'),
                    api.get('/configs/custom_gallery_pages'),
                    api.get('/configs/page_designs'),
                    api.get('/configs/event_letters'),
                    api.get('/configs/registration_fields')
                ]);
                if (visualRes.data) setConfig(prev => ({ ...prev, ...visualRes.data }));
                if (pagesRes.data) setPageControls(prev => ({ ...prev, ...pagesRes.data }));
                if (customRes.data) setCustomPages(customRes.data);
                if (designsRes.data) setPageDesigns(prev => ({ ...prev, ...designsRes.data }));
                if (lettersRes.data) setLetters(prev => ({ 
                    ...prev, 
                    ...lettersRes.data,
                    certificateData: { ...prev.certificateData, ...(lettersRes.data.certificateData || {}) },
                    thanksData: { ...prev.thanksData, ...(lettersRes.data.thanksData || {}) }
                }));
                if (regRes.data) setRegFields(prev => ({ ...prev, ...regRes.data }));
            } catch (error) {
                console.error("Config not found, using defaults", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchConfig();
    }, []);

    const handleSave = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setMessage('');
        try {
            await Promise.all([
                api.put('/configs/visual_identity', { value: config }),
                api.put('/configs/page_controls', { value: pageControls }),
                api.put('/configs/custom_gallery_pages', { value: customPages }),
                api.put('/configs/page_designs', { value: pageDesigns }),
                api.put('/configs/event_letters', { value: letters }),
                api.put('/configs/registration_fields', { value: regFields })
            ]);
            setMessage('Configuraciones actualizadas con éxito.');
            setTimeout(() => setMessage(''), 3000);
        } catch (error) {
            console.error("Error saving", error);
            setMessage('Error al guardar la configuración.');
        } finally {
            setIsSaving(false);
        }
    };

    const updatePageDesign = (page, key, value) => {
        setPageDesigns(prev => ({
            ...prev,
            [page]: { ...prev[page], [key]: value }
        }));
    };

    return (
        <div className="max-w-6xl mx-auto animate-fadeIn pb-32">
            <header className="mb-10">
                <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight text-center italic uppercase">Configuración de Experiencia</h1>
                <p className="text-slate-500 mt-2 text-center font-medium">Gestiona la identidad visual global y el diseño específico de cada sección.</p>
            </header>

            {isLoading ? (
                <div className="flex flex-col items-center justify-center py-20 bg-white rounded-[50px] shadow-sm">
                    <div className="w-10 h-10 border-4 border-slate-100 border-t-purple-600 rounded-full animate-spin"></div>
                    <p className="mt-4 text-xs font-black uppercase tracking-widest text-slate-400">Sincronizando con el servidor</p>
                </div>
            ) : (
                <div className="space-y-12">
                    {/* Visual Identity Panel */}
                    <div className="bg-white rounded-[50px] shadow-sm border border-slate-100 overflow-hidden flex flex-col lg:flex-row min-h-[450px]">
                        <div className="lg:w-1/3 p-12 bg-slate-50 flex flex-col items-center justify-center border-r border-slate-100 relative">
                            <div className="absolute top-8 left-8 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">Identidad Global</div>
                            <div className="w-full max-w-[200px] h-32 bg-white rounded-[35px] shadow-xl flex items-center justify-center text-4xl font-black text-white" style={{ backgroundColor: config.primaryColor }}>
                                N
                            </div>
                            <div className="mt-8 text-center">
                                <p className="text-xs font-bold text-slate-900">Muestra de Marca</p>
                            </div>
                        </div>

                        <div className="lg:w-2/3 p-12 space-y-10">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div>
                                    <label className="block text-slate-400 text-[10px] font-black tracking-widest uppercase mb-4 pl-1">Colores del Tema</label>
                                    <div className="flex items-center space-x-3">
                                        <input type="color" className="w-12 h-12 rounded-xl border-none cursor-pointer" value={config.primaryColor} onChange={e => setConfig({...config, primaryColor: e.target.value})} />
                                        <input className="bg-slate-100 border-none p-4 rounded-xl font-mono text-xs uppercase" value={config.primaryColor} onChange={e => setConfig({...config, primaryColor: e.target.value})} />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-slate-400 text-[10px] font-black tracking-widest uppercase mb-4 pl-1">URL Logo Corporativo</label>
                                    <input className="w-full bg-slate-100 border-none p-4 rounded-2xl text-sm" placeholder="URL .png" value={config.logoUrl} onChange={e => setConfig({...config, logoUrl: e.target.value})} />
                                </div>
                                <div className="md:col-span-2">
                                    <label className="block text-slate-400 text-[10px] font-black tracking-widest uppercase mb-4 pl-1">Imagen de Fondo Global</label>
                                    <input 
                                        className="w-full bg-slate-100 border-none p-4 rounded-2xl text-sm" 
                                        placeholder="URL de la imagen de fondo principal" 
                                        value={config.backgroundImage} 
                                        onChange={e => setConfig({...config, backgroundImage: e.target.value})} 
                                    />
                                    <p className="mt-2 text-[9px] text-slate-400 uppercase font-bold tracking-wider italic">* Esta imagen se usará como base para todas las secciones.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Page Specific Designs Section */}
                    <div className="bg-white rounded-[50px] shadow-sm border border-slate-100 p-12">
                        <div className="mb-12">
                            <h2 className="text-2xl font-black text-slate-900 flex items-center uppercase italic">
                                <span className="mr-4">🎨</span> Diseño y Personalización por Página
                            </h2>
                            <p className="text-slate-400 text-sm font-medium mt-1">Configura el fondo y elementos visuales para cada sección del evento.</p>
                        </div>

                        <div className="space-y-8">
                            {Object.entries(pageDesigns).map(([page, settings]) => (
                                <div key={page} className="bg-slate-50 rounded-[40px] border border-slate-100 overflow-hidden group transition-all hover:shadow-2xl hover:bg-white">
                                    {/* Page Header */}
                                    <div className="px-10 py-6 bg-white/50 border-b border-slate-100 flex justify-between items-center">
                                        <div className="flex items-center gap-4">
                                            <span className="w-3 h-3 rounded-full" style={{ backgroundColor: settings.enabled ? '#10b981' : '#94a3b8' }}></span>
                                            <h3 className="text-xl font-black text-slate-900 uppercase tracking-tighter italic">{page}</h3>
                                        </div>
                                        <div className="flex gap-2">
                                            <button 
                                                onClick={() => updatePageDesign(page, 'enabled', !settings.enabled)}
                                                className={`px-6 py-2 rounded-2xl text-[9px] font-black uppercase tracking-widest transition-all ${settings.enabled ? 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/20' : 'bg-slate-200 text-slate-500'}`}
                                            >
                                                {settings.enabled ? 'Sección Activa' : 'Sección Oculta'}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="p-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
                                        {/* Toggles Column */}
                                        <div className="lg:col-span-3 space-y-6">
                                            <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Visibilidad</label>
                                            <div className="flex flex-col gap-3">
                                                <button 
                                                    onClick={() => updatePageDesign(page, 'showBrain', !settings.showBrain)}
                                                    className={`flex items-center justify-between px-5 py-3 rounded-2xl text-[9px] font-black uppercase tracking-widest transition-all ${settings.showBrain ? 'bg-purple-50 text-purple-600 border border-purple-100' : 'bg-white border border-slate-100 text-slate-300'}`}
                                                >
                                                    <span>🧠 Cerebro</span>
                                                    <span>{settings.showBrain ? 'SÍ' : 'NO'}</span>
                                                </button>
                                                <button 
                                                    onClick={() => updatePageDesign(page, 'showTitle', !settings.showTitle)}
                                                    className={`flex items-center justify-between px-5 py-3 rounded-2xl text-[9px] font-black uppercase tracking-widest transition-all ${settings.showTitle !== false ? 'bg-blue-50 text-blue-600 border border-blue-100' : 'bg-white border border-slate-100 text-slate-300'}`}
                                                >
                                                    <span>📝 Título</span>
                                                    <span>{settings.showTitle !== false ? 'SÍ' : 'NO'}</span>
                                                </button>
                                                {page === 'agenda' && (
                                                    <button 
                                                        onClick={() => updatePageDesign(page, 'agendaImageOnly', !settings.agendaImageOnly)}
                                                        className={`flex items-center justify-between px-5 py-3 rounded-2xl text-[9px] font-black uppercase tracking-widest transition-all ${settings.agendaImageOnly ? 'bg-orange-50 text-orange-600 border border-orange-100' : 'bg-white border border-slate-100 text-slate-300'}`}
                                                    >
                                                        <span>🖼️ Solo Imagen</span>
                                                        <span>{settings.agendaImageOnly ? 'SÍ' : 'NO'}</span>
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {/* Content Inputs */}
                                        <div className="lg:col-span-4 space-y-6">
                                            <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Contenido</label>
                                            <div className="space-y-4">
                                                <div>
                                                    <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-1 ml-4">Título Personalizado</p>
                                                    <input 
                                                        className="w-full bg-white border border-slate-100 p-4 rounded-2xl text-xs font-bold shadow-sm focus:ring-4 focus:ring-slate-100 transition-all"
                                                        placeholder="Título de la página"
                                                        value={settings.title || ''}
                                                        onChange={e => updatePageDesign(page, 'title', e.target.value)}
                                                    />
                                                </div>
                                                <div>
                                                    <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-1 ml-4">Subtítulo Personalizado</p>
                                                    <input 
                                                        className="w-full bg-white border border-slate-100 p-4 rounded-2xl text-xs font-bold shadow-sm focus:ring-4 focus:ring-slate-100 transition-all"
                                                        placeholder="Subtítulo de la página"
                                                        value={settings.subtitle || ''}
                                                        onChange={e => updatePageDesign(page, 'subtitle', e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Appearance Column */}
                                        <div className="lg:col-span-5 space-y-6">
                                            <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Apariencia y Fondos</label>
                                            <div className="space-y-4">
                                                <div className="flex gap-4">
                                                    <div className="flex-grow">
                                                        <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-1 ml-4">Fondo de Sección (URL)</p>
                                                        <input 
                                                            className="w-full bg-white border border-slate-100 p-4 rounded-2xl text-[10px] font-medium shadow-sm focus:ring-4 focus:ring-slate-100 transition-all"
                                                            placeholder="URL del fondo"
                                                            value={settings.bgImage}
                                                            onChange={e => updatePageDesign(page, 'bgImage', e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="w-16 h-16 rounded-2xl bg-slate-200 overflow-hidden border-2 border-white shadow-md shrink-0">
                                                        <img src={settings.bgImage} className="w-full h-full object-cover" alt="Preview" />
                                                    </div>
                                                </div>

                                                {page === 'gallery' && (
                                                    <div className="space-y-4 pt-4 border-t border-slate-100">
                                                        <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Tipo de Galería Principal</p>
                                                        <div className="grid grid-cols-3 gap-2">
                                                            {['upload', 'embed', 'redirect'].map(type => (
                                                                <button 
                                                                    key={type}
                                                                    onClick={() => updatePageDesign(page, 'type', type)}
                                                                    className={`py-3 rounded-xl text-[9px] font-black uppercase tracking-widest border ${settings.type === type ? 'bg-slate-900 text-white border-slate-900 shadow-md' : 'bg-white text-slate-400 border-slate-100'}`}
                                                                >
                                                                    {type}
                                                                </button>
                                                            ))}
                                                        </div>
                                                        {(settings.type === 'embed' || settings.type === 'redirect') && (
                                                            <input 
                                                                className="w-full bg-white border border-slate-100 p-4 rounded-2xl text-[10px] font-mono shadow-sm" 
                                                                placeholder="URL de Destino" 
                                                                value={settings.url || ''} 
                                                                onChange={e => updatePageDesign(page, 'url', e.target.value)} 
                                                            />
                                                        )}
                                                    </div>
                                                )}

                                                {page === 'agenda' && settings.agendaImageOnly && (
                                                    <div className="p-5 bg-orange-50 rounded-3xl border border-orange-100 animate-fadeIn">
                                                        <p className="text-[8px] font-black text-orange-400 uppercase tracking-widest mb-2 ml-1">Imagen de Agenda Estática</p>
                                                        <input 
                                                            className="w-full bg-white border border-orange-200 p-4 rounded-2xl text-[10px] font-bold text-orange-600 shadow-sm"
                                                            placeholder="URL de la imagen (PNG/JPG)"
                                                            value={settings.staticImage || ''}
                                                            onChange={e => updatePageDesign(page, 'staticImage', e.target.value)}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Event Letters Section */}
                    <div className="bg-white rounded-[50px] shadow-sm border border-slate-100 p-12">
                        <div className="mb-12">
                            <h2 className="text-2xl font-black text-slate-900 flex items-center uppercase italic">
                                <span className="mr-4">✉️</span> Textos de Comunicaciones
                            </h2>
                            <p className="text-slate-400 text-sm font-medium mt-1">Configura las cartas de bienvenida, agradecimiento y aspectos logísticos.</p>
                        </div>

                        <div className="space-y-12">
                            {/* Welcome Letter Type Toggle */}
                            <div className="bg-slate-50 p-8 rounded-[40px] border border-slate-100">
                                <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-6 ml-4">Tipo de Bienvenida / Logística</label>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    {['text', 'image', 'structured'].map(type => (
                                        <button 
                                            key={type}
                                            onClick={() => setLetters({...letters, welcomeType: type})}
                                            className={`p-6 rounded-[30px] border-2 transition-all flex flex-col items-center gap-3 ${letters.welcomeType === type ? 'bg-purple-600 border-purple-600 text-white shadow-xl shadow-purple-900/20' : 'bg-white border-slate-100 text-slate-400 hover:border-purple-200'}`}
                                        >
                                            <span className="text-2xl">{type === 'text' ? '📝' : type === 'image' ? '🖼️' : '🏗️'}</span>
                                            <span className="text-[10px] font-black uppercase tracking-widest">{type === 'text' ? 'Texto Plano' : type === 'image' ? 'Solo Imagen' : 'Estructurado (Diseño)'}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {letters.welcomeType === 'text' && (
                                <div className="animate-fadeIn">
                                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-4 ml-4">Carta de Bienvenida (Texto)</label>
                                    <p className="text-[9px] text-slate-400 uppercase mb-4 ml-4">Usa {'{name}'} y {'{lastName}'} para personalizar.</p>
                                    <textarea 
                                        className="w-full bg-slate-50 border border-slate-100 p-8 rounded-[40px] text-sm font-medium shadow-inner min-h-[150px] focus:bg-white transition-all"
                                        value={letters.welcome}
                                        onChange={e => setLetters({...letters, welcome: e.target.value})}
                                    />
                                </div>
                            )}

                            {letters.welcomeType === 'structured' && (
                                <div className="animate-fadeIn space-y-8">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest">Secciones Logísticas</label>
                                        <button 
                                            onClick={() => {
                                                const currentData = letters.structuredData || [];
                                                setLetters({...letters, structuredData: [...currentData, { title: 'Nueva Sección', icon: '📍', content: '', borderColor: '#9d4edd' }]});
                                            }}
                                            className="text-purple-600 font-black text-[10px] uppercase tracking-widest"
                                        >
                                            + Añadir Sección
                                        </button>
                                    </div>
                                    
                                    <div className="grid gap-6">
                                        {(letters.structuredData || []).map((item, idx) => (
                                            <div key={idx} className="bg-slate-50 p-8 rounded-[40px] border border-slate-100 space-y-6 relative group">
                                                <button 
                                                    onClick={() => {
                                                        const newData = [...letters.structuredData];
                                                        newData.splice(idx, 1);
                                                        setLetters({...letters, structuredData: newData});
                                                    }}
                                                    className="absolute top-6 right-6 w-8 h-8 rounded-full bg-red-50 text-red-400 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-all"
                                                >
                                                    ✕
                                                </button>

                                                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                                                    <div>
                                                        <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Icono (Emoji)</p>
                                                        <input 
                                                            className="w-full bg-white border border-slate-100 p-4 rounded-2xl text-center text-xl"
                                                            value={item.icon}
                                                            onChange={e => {
                                                                const newData = [...letters.structuredData];
                                                                newData[idx].icon = e.target.value;
                                                                setLetters({...letters, structuredData: newData});
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="md:col-span-2">
                                                        <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Título</p>
                                                        <input 
                                                            className="w-full bg-white border border-slate-100 p-4 rounded-2xl text-xs font-bold uppercase"
                                                            value={item.title}
                                                            onChange={e => {
                                                                const newData = [...letters.structuredData];
                                                                newData[idx].title = e.target.value;
                                                                setLetters({...letters, structuredData: newData});
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Color Borde</p>
                                                        <div className="flex gap-2">
                                                            <input 
                                                                type="color"
                                                                className="w-12 h-12 rounded-xl border-none cursor-pointer"
                                                                value={item.borderColor}
                                                                onChange={e => {
                                                                    const newData = [...letters.structuredData];
                                                                    newData[idx].borderColor = e.target.value;
                                                                    setLetters({...letters, structuredData: newData});
                                                                }}
                                                            />
                                                            <input 
                                                                className="flex-grow bg-white border border-slate-100 p-4 rounded-2xl text-[10px] font-mono"
                                                                value={item.borderColor}
                                                                onChange={e => {
                                                                    const newData = [...letters.structuredData];
                                                                    newData[idx].borderColor = e.target.value;
                                                                    setLetters({...letters, structuredData: newData});
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Contenido (Usa **texto** para negrita)</p>
                                                    <textarea 
                                                        className="w-full bg-white border border-slate-100 p-6 rounded-[30px] text-xs font-medium min-h-[100px]"
                                                        value={item.content}
                                                        onChange={e => {
                                                            const newData = [...letters.structuredData];
                                                            newData[idx].content = e.target.value;
                                                            setLetters({...letters, structuredData: newData});
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 border-t border-slate-100 pt-10">
                                <div>
                                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-4 ml-4">Carta de Agradecimiento</label>
                                    <textarea 
                                        className="w-full bg-slate-50 border border-slate-100 p-8 rounded-[40px] text-sm font-medium shadow-inner min-h-[150px] focus:bg-white transition-all"
                                        value={letters.thanks}
                                        onChange={e => setLetters({...letters, thanks: e.target.value})}
                                    />
                                </div>
                                <div>
                                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-4 ml-4">Texto de Certificación (Básico)</label>
                                    <textarea 
                                        className="w-full bg-slate-50 border border-slate-100 p-8 rounded-[40px] text-sm font-medium shadow-inner min-h-[150px] focus:bg-white transition-all"
                                        value={letters.certificate}
                                        onChange={e => setLetters({...letters, certificate: e.target.value})}
                                    />
                                </div>
                            </div>

                            {/* New Certificate Visual Editor */}
                            <div className="border-t border-slate-100 pt-10 animate-fadeIn">
                                <div className="flex justify-between items-center mb-8">
                                    <div>
                                        <h3 className="text-xl font-black text-slate-900 uppercase italic">🎓 Editor Visual de Certificado</h3>
                                        <p className="text-slate-400 text-[10px] font-bold uppercase tracking-widest">Ubica el nombre del asistente sobre la imagen.</p>
                                    </div>
                                    <button 
                                        onClick={() => setLetters({...letters, certificateData: { ...letters.certificateData, bypassAttendance: !letters.certificateData?.bypassAttendance }})}
                                        className={`px-6 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all ${letters.certificateData?.bypassAttendance ? 'bg-orange-500 text-white shadow-lg' : 'bg-slate-100 text-slate-400'}`}
                                    >
                                        {letters.certificateData?.bypassAttendance ? '🔓 Sin Validación QR' : '🔒 Requiere Asistencia (QR)'}
                                    </button>
                                </div>

                                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                                    {/* Settings */}
                                    <div className="space-y-6">
                                        <div>
                                            <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">URL de la Imagen Base</p>
                                            <input 
                                                className="w-full bg-slate-50 border border-slate-100 p-4 rounded-2xl text-[10px] font-mono"
                                                value={letters.certificateData?.imageUrl || 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Certificado_4toNeuroUpdate_web.png'}
                                                onChange={e => setLetters({...letters, certificateData: { ...letters.certificateData, imageUrl: e.target.value }})}
                                            />
                                        </div>
                                        <div className="grid grid-cols-2 gap-4">
                                            <div>
                                                <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Tamaño Fuente (px)</p>
                                                <input 
                                                    type="number"
                                                    className="w-full bg-slate-50 border border-slate-100 p-4 rounded-2xl text-xs font-bold"
                                                    value={letters.certificateData?.fontSize || 40}
                                                    onChange={e => setLetters({...letters, certificateData: { ...letters.certificateData, fontSize: parseInt(e.target.value) }})}
                                                />
                                            </div>
                                            <div>
                                                <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Color Texto</p>
                                                <input 
                                                    type="color"
                                                    className="w-full h-12 bg-slate-50 border border-slate-100 p-1 rounded-2xl cursor-pointer"
                                                    value={letters.certificateData?.color || '#000000'}
                                                    onChange={e => setLetters({...letters, certificateData: { ...letters.certificateData, color: e.target.value }})}
                                                />
                                            </div>
                                        </div>
                                        <div className="p-6 bg-blue-50 rounded-[30px] border border-blue-100">
                                            <p className="text-[9px] text-blue-400 font-black uppercase tracking-widest mb-2">Instrucciones</p>
                                            <p className="text-[11px] text-blue-600 font-medium leading-relaxed">Haz clic en cualquier parte de la imagen a la derecha para ubicar el centro del nombre del asistente.</p>
                                        </div>
                                    </div>

                                    {/* Visual Editor Canvas */}
                                    <div className="lg:col-span-2">
                                        <div 
                                            className="relative bg-slate-200 rounded-[40px] border-4 border-white shadow-2xl overflow-hidden cursor-crosshair"
                                            onClick={(e) => {
                                                const rect = e.currentTarget.getBoundingClientRect();
                                                const x = ((e.clientX - rect.left) / rect.width) * 100;
                                                const y = ((e.clientY - rect.top) / rect.height) * 100;
                                                setLetters({...letters, certificateData: { ...letters.certificateData, x, y }});
                                            }}
                                        >
                                            <img 
                                                src={letters.certificateData?.imageUrl || 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Certificado_4toNeuroUpdate_web.png'} 
                                                alt="Preview" 
                                                className="w-full h-auto pointer-events-none"
                                            />
                                            <div 
                                                className="absolute pointer-events-none flex items-center justify-center whitespace-nowrap font-black italic uppercase tracking-tighter"
                                                style={{ 
                                                    left: `${letters.certificateData?.x || 50}%`, 
                                                    top: `${letters.certificateData?.y || 50}%`,
                                                    fontSize: `${(letters.certificateData?.fontSize || 40) / 4}px`, // Scaled for preview
                                                    color: letters.certificateData?.color || '#000000',
                                                    transform: 'translate(-50%, -50%)'
                                                }}
                                            >
                                                Nombre del Participante
                                            </div>
                                            {/* Horizontal/Vertical Guides */}
                                            <div className="absolute top-0 bottom-0 border-l border-white/30 pointer-events-none" style={{ left: `${letters.certificateData?.x || 50}%` }}></div>
                                            <div className="absolute left-0 right-0 border-t border-white/30 pointer-events-none" style={{ top: `${letters.certificateData?.y || 50}%` }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Thanks Letter Type Toggle */}
                    <div className="bg-white rounded-[50px] shadow-sm border border-slate-100 p-12">
                        <div className="mb-12">
                            <h2 className="text-2xl font-black text-slate-900 flex items-center uppercase italic">
                                <span className="mr-4">🙏</span> Formato de Agradecimiento
                            </h2>
                            <p className="text-slate-400 text-sm font-medium mt-1">Elige entre una imagen dinámica personalizada o un diseño estructurado.</p>
                        </div>

                        <div className="bg-slate-50 p-8 rounded-[40px] border border-slate-100 mb-10">
                            <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-6 ml-4">Tipo de Agradecimiento</label>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {['image', 'structured'].map(type => (
                                    <button 
                                        key={type}
                                        onClick={() => setLetters({...letters, thanksType: type})}
                                        className={`p-6 rounded-[30px] border-2 transition-all flex flex-col items-center gap-3 ${letters.thanksType === type ? 'bg-emerald-600 border-emerald-600 text-white shadow-xl shadow-emerald-900/20' : 'bg-white border-slate-100 text-slate-400 hover:border-emerald-200'}`}
                                    >
                                        <span className="text-2xl">{type === 'image' ? '🖼️' : '🏗️'}</span>
                                        <span className="text-[10px] font-black uppercase tracking-widest">{type === 'image' ? 'Imagen Personalizada' : 'Diseño Estructurado (Iconos)'}</span>
                                    </button>
                                ))}
                            </div>
                        </div>

                        {letters.thanksType === 'structured' && (
                            <div className="animate-fadeIn space-y-8">
                                <div className="flex justify-between items-center px-4">
                                    <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest">Secciones de Agradecimiento</label>
                                    <button 
                                        onClick={() => {
                                            const currentData = letters.thanksStructuredData || [];
                                            setLetters({...letters, thanksStructuredData: [...currentData, { title: 'Nueva Sección', icon: '⭐', content: '', borderColor: '#10b981' }]});
                                        }}
                                        className="text-emerald-600 font-black text-[10px] uppercase tracking-widest"
                                    >
                                        + Añadir Sección
                                    </button>
                                </div>
                                
                                <div className="grid gap-6">
                                    {(letters.thanksStructuredData || []).map((item, idx) => (
                                        <div key={idx} className="bg-slate-50 p-8 rounded-[40px] border border-slate-100 space-y-6 relative group">
                                            <button 
                                                onClick={() => {
                                                    const newData = [...letters.thanksStructuredData];
                                                    newData.splice(idx, 1);
                                                    setLetters({...letters, thanksStructuredData: newData});
                                                }}
                                                className="absolute top-6 right-6 w-8 h-8 rounded-full bg-red-50 text-red-400 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-all"
                                            >
                                                ✕
                                            </button>

                                            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                                                <div>
                                                    <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Icono</p>
                                                    <input 
                                                        className="w-full bg-white border border-slate-100 p-4 rounded-2xl text-center text-xl"
                                                        value={item.icon}
                                                        onChange={e => {
                                                            const newData = [...letters.thanksStructuredData];
                                                            newData[idx].icon = e.target.value;
                                                            setLetters({...letters, thanksStructuredData: newData});
                                                        }}
                                                    />
                                                </div>
                                                <div className="md:col-span-2">
                                                    <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Título</p>
                                                    <input 
                                                        className="w-full bg-white border border-slate-100 p-4 rounded-2xl text-xs font-bold uppercase"
                                                        value={item.title}
                                                        onChange={e => {
                                                            const newData = [...letters.thanksStructuredData];
                                                            newData[idx].title = e.target.value;
                                                            setLetters({...letters, thanksStructuredData: newData});
                                                        }}
                                                    />
                                                </div>
                                                <div>
                                                    <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Color Borde</p>
                                                    <div className="flex gap-2">
                                                        <input 
                                                            type="color"
                                                            className="w-12 h-12 rounded-xl border-none cursor-pointer"
                                                            value={item.borderColor}
                                                            onChange={e => {
                                                                const newData = [...letters.thanksStructuredData];
                                                                newData[idx].borderColor = e.target.value;
                                                                setLetters({...letters, thanksStructuredData: newData});
                                                            }}
                                                        />
                                                        <input 
                                                            className="flex-grow bg-white border border-slate-100 p-4 rounded-2xl text-[10px] font-mono"
                                                            value={item.borderColor}
                                                            onChange={e => {
                                                                const newData = [...letters.thanksStructuredData];
                                                                newData[idx].borderColor = e.target.value;
                                                                setLetters({...letters, thanksStructuredData: newData});
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Contenido</p>
                                                <textarea 
                                                    className="w-full bg-white border border-slate-100 p-6 rounded-[30px] text-xs font-medium min-h-[100px]"
                                                    value={item.content}
                                                    onChange={e => {
                                                        const newData = [...letters.thanksStructuredData];
                                                        newData[idx].content = e.target.value;
                                                        setLetters({...letters, thanksStructuredData: newData});
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Thanks Letter Visual Editor */}
                    <div className="bg-white rounded-[50px] shadow-sm border border-slate-100 p-12">
                        <div className="flex justify-between items-center mb-8">
                            <div>
                                <h3 className="text-xl font-black text-slate-900 uppercase italic">✨ Editor Visual de Agradecimiento</h3>
                                <p className="text-slate-400 text-[10px] font-bold uppercase tracking-widest">Ubica el nombre del asistente en la pantalla final.</p>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                            {/* Settings */}
                            <div className="space-y-6">
                                <div>
                                    <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">URL de la Imagen de Fondo</p>
                                    <input 
                                        className="w-full bg-slate-50 border border-slate-100 p-4 rounded-2xl text-[10px] font-mono"
                                        value={letters.thanksData?.imageUrl || ''}
                                        onChange={e => setLetters({...letters, thanksData: { ...letters.thanksData, imageUrl: e.target.value }})}
                                    />
                                </div>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Tamaño Fuente (px)</p>
                                        <input 
                                            type="number"
                                            className="w-full bg-slate-50 border border-slate-100 p-4 rounded-2xl text-xs font-bold"
                                            value={letters.thanksData?.fontSize || 40}
                                            onChange={e => setLetters({...letters, thanksData: { ...letters.thanksData, fontSize: parseInt(e.target.value) }})}
                                        />
                                    </div>
                                    <div>
                                        <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">Color Texto</p>
                                        <input 
                                            type="color"
                                            className="w-full h-12 bg-slate-50 border border-slate-100 p-1 rounded-2xl cursor-pointer"
                                            value={letters.thanksData?.color || '#ffffff'}
                                            onChange={e => setLetters({...letters, thanksData: { ...letters.thanksData, color: e.target.value }})}
                                        />
                                    </div>
                                </div>
                                <div className="p-6 bg-emerald-50 rounded-[30px] border border-emerald-100">
                                    <p className="text-[9px] text-emerald-400 font-black uppercase tracking-widest mb-2">Diseño Premium</p>
                                    <p className="text-[11px] text-emerald-600 font-medium leading-relaxed">Ubica el nombre del asistente sobre una imagen de fondo de alta calidad para la pantalla de agradecimiento.</p>
                                </div>
                            </div>

                            {/* Visual Editor Canvas */}
                            <div className="lg:col-span-2">
                                <div 
                                    className="relative bg-slate-200 rounded-[40px] border-4 border-white shadow-2xl overflow-hidden cursor-crosshair"
                                    onClick={(e) => {
                                        const rect = e.currentTarget.getBoundingClientRect();
                                        const x = ((e.clientX - rect.left) / rect.width) * 100;
                                        const y = ((e.clientY - rect.top) / rect.height) * 100;
                                        setLetters({...letters, thanksData: { ...letters.thanksData, x, y }});
                                    }}
                                >
                                    <img 
                                        src={letters.thanksData?.imageUrl || 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Fondo_3_ColorGeneral_Horizontal.png'} 
                                        alt="Preview" 
                                        className="w-full h-auto pointer-events-none"
                                    />
                                    <div 
                                        className="absolute pointer-events-none flex items-center justify-center whitespace-nowrap font-black italic uppercase tracking-tighter"
                                        style={{ 
                                            left: `${letters.thanksData?.x || 50}%`, 
                                            top: `${letters.thanksData?.y || 50}%`,
                                            fontSize: `${(letters.thanksData?.fontSize || 40) / 4}px`, 
                                            color: letters.thanksData?.color || '#ffffff',
                                            transform: 'translate(-50%, -50%)'
                                        }}
                                    >
                                        Nombre del Participante
                                    </div>
                                    <div className="absolute top-0 bottom-0 border-l border-white/30 pointer-events-none" style={{ left: `${letters.thanksData?.x || 50}%` }}></div>
                                    <div className="absolute left-0 right-0 border-t border-white/30 pointer-events-none" style={{ top: `${letters.thanksData?.y || 50}%` }}></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white rounded-[50px] shadow-sm border border-slate-100 p-12">
                        <div className="flex justify-between items-center mb-10">
                            <h2 className="text-2xl font-black text-slate-900 uppercase italic">📸 Galerías de Fotos</h2>
                            <button 
                                onClick={() => setCustomPages([...customPages, { id: Date.now(), title: 'Nueva Galería', slug: 'nueva-galeria', icon: '🖼️', type: 'upload', url: '', images: [] }])}
                                className="bg-slate-900 text-white px-8 py-4 rounded-[30px] font-black text-[10px] uppercase tracking-widest shadow-lg hover:scale-105 active:scale-95 transition-all"
                            >
                                + Nueva Galería
                            </button>
                        </div>
                        {/* Custom pages mapping */}
                        <div className="grid grid-cols-1 gap-6">
                            {customPages.map((page, idx) => (
                                <div key={page.id} className="p-10 bg-slate-50 rounded-[40px] border border-slate-100 relative shadow-sm group">
                                    <button 
                                        onClick={() => setCustomPages(customPages.filter(p => p.id !== page.id))} 
                                        className="absolute top-6 right-6 w-10 h-10 rounded-full bg-red-50 text-red-400 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-all shadow-sm"
                                    >
                                        ✕
                                    </button>

                                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                                        <div className="lg:col-span-1 space-y-4">
                                            <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest ml-2">Título e Icono</p>
                                            <div className="flex gap-4">
                                                <input className="w-16 bg-white border border-slate-100 p-4 rounded-2xl text-center text-xl shadow-sm" value={page.icon || '🖼️'} onChange={e => { let n = [...customPages]; n[idx].icon = e.target.value; setCustomPages(n); }} />
                                                <input className="flex-grow bg-white border border-slate-100 p-4 rounded-2xl text-xs font-black uppercase italic tracking-tighter shadow-sm" value={page.title} onChange={e => { let n = [...customPages]; n[idx].title = e.target.value; setCustomPages(n); }} />
                                            </div>
                                            <input className="w-full bg-white border border-slate-100 p-4 rounded-2xl text-[10px] font-medium text-slate-400" value={page.slug} placeholder="slug-de-url" onChange={e => { let n = [...customPages]; n[idx].slug = e.target.value; setCustomPages(n); }} />
                                        </div>

                                        <div className="lg:col-span-3 space-y-6">
                                            <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest ml-2">Tipo de Galería y Configuración</p>
                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                {[
                                                    { id: 'upload', label: 'Subir Fotos', icon: '📸', desc: 'Gestionado por Staff' },
                                                    { id: 'embed', label: 'Embeber Página', icon: '🌐', desc: 'Iframe 100% ancho' },
                                                    { id: 'redirect', label: 'Redirección', icon: '🔗', desc: 'Link externo (Ventana nueva)' }
                                                ].map(mode => (
                                                    <button 
                                                        key={mode.id}
                                                        onClick={() => { let n = [...customPages]; n[idx].type = mode.id; setCustomPages(n); }}
                                                        className={`p-6 rounded-[30px] border-2 transition-all flex flex-col items-center gap-2 ${page.type === mode.id ? 'bg-slate-900 border-slate-900 text-white shadow-xl' : 'bg-white border-slate-100 text-slate-400 hover:border-slate-200'}`}
                                                    >
                                                        <span className="text-xl">{mode.icon}</span>
                                                        <span className="text-[9px] font-black uppercase tracking-widest">{mode.label}</span>
                                                        <span className="text-[7px] font-bold uppercase opacity-60">{mode.desc}</span>
                                                    </button>
                                                ))}
                                            </div>

                                            {(page.type === 'embed' || page.type === 'redirect') && (
                                                <div className="animate-fadeIn">
                                                    <p className="text-[8px] font-black text-slate-300 uppercase tracking-widest mb-2 ml-4">URL de Destino (https://...)</p>
                                                    <input 
                                                        className="w-full bg-white border border-slate-100 p-4 rounded-2xl text-xs font-mono shadow-inner" 
                                                        placeholder="URL externa" 
                                                        value={page.url || ''} 
                                                        onChange={e => { let n = [...customPages]; n[idx].url = e.target.value; setCustomPages(n); }} 
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="fixed bottom-10 left-1/2 -translate-x-1/2 z-[100]">
                        <button 
                            onClick={handleSave}
                            disabled={isSaving}
                            className={`px-20 py-6 rounded-[40px] font-black uppercase tracking-[0.3em] text-white shadow-2xl transition-all transform active:scale-95 ${isSaving ? 'bg-slate-400' : 'bg-purple-600 hover:scale-105 hover:bg-purple-500'}`}
                        >
                            {isSaving ? 'Sincronizando...' : 'Guardar Cambios Globales'}
                        </button>
                        {message && (
                            <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-max bg-emerald-500 text-white px-10 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest animate-bounce">
                                {message}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Configs;
